import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import PartPaymentList from "../../components/PartPayment/PartPaymentList";

const PartPayment = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <PartPaymentList />
                    </div>
                </div>
            </div>
        </>
    )
}
export default PartPayment;
